export const INDEX_LOADING = "INDEX_LOADING";
export const INDEX_SUCCESS = "INDEX_SUCCESS";
export const INDEX_FAIL = "INDEX_FAIL";

export const UPDATE_MENU_INDEX="UPDATE_MENU_INDEX"
// INDEX_LOGGED_IN,
// INDEX_NOT_LOGGED_IN,
// INDEX_ADDRESS_PENDING,
// INDEX_EMAIL_PENDING,
